
const PROD_ALLOWED_REDIRECT_URI = [
  "groceries.asda.com",
  "login.whisk.com",
  "list.whisk.com",
  "login.whisk.com",
  "list.whisk.com",
  "login-dev.whisk.com",
  "www.asdapriceguarantee.co.uk",
  "www.mysupermarket.co.uk",
  "oauth-redirect.googleusercontent.com",
  "www.asda.com",
  "groceries-dev.asda.com",
  "groceries-nv.asda.com",
  "www-dev.asda.com",
  "development-direct.asda.com",
  "direct.asda.com",
  "staging.direct.asda.com",
  "global.staging.direct.asda.com",
  "groceries-stage.asda.com",
  "global.direct.asda.com",
  "asdagiftcards.com",
  "www.asdagiftcards.com",
  "asdafunpackedsummer.com",
  "tofunce2345.azurewebsites.net",
  "asda.jaja.finance",
  "www-stage.asda.com",
  "www.mysupermarket.co.uk",
  "www.asdapriceguarantee.co.uk",
  "stage.asdapriceguarantee.prod.walmart.com",
  "oauth-redirect.googleusercontent.com",
  "list-staging.whisk.com",
  "login-dev.whisk.com",
  'login.whisk-dev.com',
  'rewards.asda.com',
  'rewards-uat.asda.com'
  ]

const QA_ALLOWED_REDIRECT_URI = [
  "groceries-dev.asda.com",
  "localhost:3000",
"login-dev.whisk.com",
"aaay-021.sandbox.us01.dx.commercecloud.salesforce.com",
"global-aaay-021.sandbox.us01.dx.commercecloud.salesforce.com",
"list.whisk.com",
"global-aacd-001.sandbox.isobarsystems.com",
"global-aacd-002.sandbox.isobarsystems.com",
"global-aacd-003.sandbox.isobarsystems.com",
"global-aacd-004.sandbox.isobarsystems.com",
"global-aacd-005.sandbox.isobarsystems.com",
"global-aacd-006.sandbox.isobarsystems.com",
"global-aacd-007.sandbox.isobarsystems.com",
"global-aacd-008.sandbox.isobarsystems.com",
"global-aacd-009.sandbox.isobarsystems.com",
"global-aacd-010.sandbox.isobarsystems.com",
"list-staging.whisk.com",
"global-aacd-011.sandbox.isobarsystems.com",
"global-aacd-012.sandbox.isobarsystems.com",
"global-aacd-013.sandbox.isobarsystems.com",
"global-aacd-014.sandbox.isobarsystems.com",
"global-aacd-015.sandbox.isobarsystems.com",
"global-aacd-016.sandbox.isobarsystems.com",
"global-aacd-017.sandbox.isobarsystems.com",
"global-aacd-018.sandbox.isobarsystems.com",
"global-aacd-019.sandbox.isobarsystems.com",
"global-aacd-020.sandbox.isobarsystems.com",
"global-dev11-web04-ecommera.demandware.net",
"global-aacd-021.sandbox.isobarsystems.com",
"global-aacd-022.sandbox.isobarsystems.com",
"global-aacd-023.sandbox.isobarsystems.com",
"global-aacd-024.sandbox.isobarsystems.com",
"global-aacd-025.sandbox.isobarsystems.com",
"global-aacd-026.sandbox.isobarsystems.com",
"global-aacd-027.sandbox.isobarsystems.com",
"aacd-001.sandbox.us01.dx.commercecloud.salesforce.com",
"aacd-002.sandbox.us01.dx.commercecloud.salesforce.com",
"aacd-003.sandbox.us01.dx.commercecloud.salesforce.com",
"global.development-direct.asda.com",
"aacd-004.sandbox.us01.dx.commercecloud.salesforce.com",
"aacd-005.sandbox.us01.dx.commercecloud.salesforce.com",
"aacd-006.sandbox.us01.dx.commercecloud.salesforce.com",
"aacd-007.sandbox.us01.dx.commercecloud.salesforce.com",
"aacd-008.sandbox.us01.dx.commercecloud.salesforce.com",
"aacd-009.sandbox.us01.dx.commercecloud.salesforce.com",
"aacd-010.sandbox.us01.dx.commercecloud.salesforce.com",
"aacd-011.sandbox.us01.dx.commercecloud.salesforce.com",
"aacd-012.sandbox.us01.dx.commercecloud.salesforce.com",
"aacd-013.sandbox.us01.dx.commercecloud.salesforce.com",
"www-qa.asda.com",
"aacd-014.sandbox.us01.dx.commercecloud.salesforce.com",
"aacd-015.sandbox.us01.dx.commercecloud.salesforce.com",
"aacd-016.sandbox.us01.dx.commercecloud.salesforce.com",
"aacd-017.sandbox.us01.dx.commercecloud.salesforce.com",
"aacd-016.sandbox.us01.dx.commercecloud.salesforce.com",
"aacd-019.sandbox.us01.dx.commercecloud.salesforce.com",
"aacd-020.sandbox.us01.dx.commercecloud.salesforce.com",
"aacd-021.sandbox.us01.dx.commercecloud.salesforce.com",
"aacd-022.sandbox.us01.dx.commercecloud.salesforce.com",
"aacd-023.sandbox.us01.dx.commercecloud.salesforce.com",
"dev26-web02-ecommera.demandware.net",
"aacd-024.sandbox.us01.dx.commercecloud.salesforce.com",
"aacd-025.sandbox.us01.dx.commercecloud.salesforce.com",
"aacd-026.sandbox.us01.dx.commercecloud.salesforce.com",
"aacd-027.sandbox.us01.dx.commercecloud.salesforce.com",
"dev35-web04-ecommera.demandware.net",
"dev22-web04-ecommera.demandware.net",
"groceries-qa.asda.com",
"dev18-web04-ecommera.demandware.net",
"dev29-web03-ecommera.demandware.net",
"dev09-web04-ecommera.demandware.net",
"dev1-web-ecommera.demandware.net",
"dev3-web-ecommera.demandware.net",
"dev6-web-ecommera.demandware.net",
"dev02-web03-ecommera.demandware.net",
"dev24-web02-ecommera.demandware.net",
"test-asda-ecommera.demandware.net",
"dev17-web03-ecommera.demandware.net",
"global.development-direct.asda.com",
"global-dev26-web02-ecommera.demandware.net",
"global-dev35-web04-ecommera.demandware.net",
"global-dev22-web04-ecommera.demandware.net",
"global-dev18-web04-ecommera.demandware.net",
"global-dev29-web03-ecommera.demandware.net",
"global-dev09-web04-ecommera.demandware.net",
"global-dev1-web-ecommera.demandware.net",
"global-dev3-web-ecommera.demandware.net",
"global-dev6-web-ecommera.demandware.net",
"global-dev02-web03-ecommera.demandware.net",
"development-direct.asda.com",
"global-dev24-web02-ecommera.demandware.net",
"global-test-asda-ecommera.demandware.net",
"global-dev17-web03-ecommera.demandware.net",
"https://asdagiftcards.com",
  "dev09-web-ecommera.demandware.net",
"https://www.asdagiftcards.com",
  "dev13-web-ecommera.demandware.net",
"dev21-web-ecommera.demandware.net",
"dev07-web-ecommera.demandware.net",
"dev35-web04-ecommera.demandware.net",
"staging.direct.asda.com",
"dev22-web04-ecommera.demandware.net",
"dev18-web04-ecommera.demandware.net",
"dev11-web04-ecommera.demandware.net",
"dev43-web04-ecommera.demandware.net",
"dev19-web-ecommera.demandware.net",
"global-dev21-web-ecommera.demandware.net",
"global-dev07-web-ecommera.demandware.net",
"global-dev13-web-ecommera.demandware.net",
"global-dev43-web04-ecommera.demandware.net",
"global-dev19-web-ecommera.demandware.net",
"direct.asda.com",
"oauth-redirect.googleusercontent.com",
"https://www.asdagiftcards.com",
  "test.asda.ecommera.demandware.net",
"https://asda-gift-card.stickeedev.com/",
  "https://asda-gift-card-sso.stickeedev.com/",
    "groceries-stage.asda.com",
"mysupermarket.co.uk",
"dev31-web-ecommera.demandware.net",
"www.mysupermarket.co.uk",
"whisk.localhost:3002",
"asda-gift-card.test",
"login.whisk-dev.com",
"rewards-dev.asda.com"
 // "asda-delorean.stickeedev.com"
]

const urlHostname = url => {
  try {
    return new URL(url).hostname;
  }
  catch(e) { return e; }
};

const getCurrentEnv = () => {
  const location = window.location.origin;
  if(location.includes("www-dev")){
    return "development"
  } else if(location.includes("www-qa")){
    return "pqa"
  } else if(location.includes("stage")){
    return "stage"
  } else {
    return "production"
  }
}

export const isValidRedirectURI = (redirectUri) => {
  const urlList = (getCurrentEnv() === "production") ? PROD_ALLOWED_REDIRECT_URI : QA_ALLOWED_REDIRECT_URI
  if (!redirectUri) return false
  return urlList.includes(urlHostname(redirectUri))
}
